module.exports = __webpack_public_path__ + "img/img05.d2839b90.png";